import { SET_SUPPRESSED_EMAILS } from "./actions";

export default {
  [SET_SUPPRESSED_EMAILS](state, suppressedEmails) {
    state.suppressedEmails = suppressedEmails;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};